import { Injectable } from '@angular/core';
import { FrameContext, Entity } from '@farris/devkit';
import { BefRepository } from '@farris/bef';
import { FormLoadingService } from '../form-loading/form-loading.service';
import { FormNotifyService } from '../form-notify.service';
import { LanguageService } from '../languag.service';
import { FormMessageService } from '../form-message.service';
import { FormErrorService } from '../error/form-error.service';

/**
 * å é¤æå¡
 */
@Injectable()
class SaveDataService {

  private notifyService: FormNotifyService;

  private messageService: FormMessageService;

  private loadingService: FormLoadingService;

  private errorService: FormErrorService;

  private languageService: LanguageService;

  private befRepository: BefRepository<any>;

  /**
   * æé å½æ°
   * @param frameContext ç»ä»¶ä¸ä¸æ
   */
  constructor(private frameContext: FrameContext) {
    this.notifyService = this.frameContext.injector.get<FormNotifyService>(FormNotifyService, null);
    this.messageService = this.frameContext.injector.get<FormMessageService>(FormMessageService, null);
    this.loadingService = this.frameContext.injector.get<FormLoadingService>(FormLoadingService, null);
    this.languageService = this.frameContext.injector.get<LanguageService>(LanguageService, null);
    this.befRepository = this.frameContext.repository as BefRepository<Entity>;
  }
}

export { SaveDataService };
